
export function downloadFile (response, filename) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([ response.body ], { type: 'application/pdf' })

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob)
  var link = document.createElement('a')
  link.href = data
  link.download = filename + '.pdf'
  link.click()
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function getSafe (fn, defaultVal) {
  try {
    return fn()
  } catch (e) {
    return defaultVal
  }
}

export const rSplitArray = (arr, el) => {
  return arr.slice(arr.indexOf(el) + 1, arr.length)
}

const toCamel = (str) => {
  return str.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const isArray = function (arr) {
  return Array.isArray(arr)
}

const isObject = function (obj) {
  return obj === Object(obj) && !isArray(obj) && typeof obj !== 'function'
}

export const keysToCamel = function (obj) {
  if (isObject(obj)) {
    const n = {}
    Object.keys(obj)
      .forEach((k) => {
        n[ toCamel(k) ] = keysToCamel(obj[ k ])
      })
    return n
  } else if (isArray(obj)) {
    return obj.map((i) => {
      return keysToCamel(i)
    })
  }
  return obj
}

export const urlJoin = (...args) =>
  args
    .join('/')
    .replace(/[/]+/g, '/')
    .replace(/^(.+):\//, '$1://')
    .replace(/^file:/, 'file:/')
    .replace(/\/(\?|&|#[^!])/g, '$1')
    .replace(/\?/g, '&')
    .replace('&', '?')

export default {
  downloadFile,
  getSafe,
  keysToCamel,
  rSplitArray,
  urlJoin
}



// WEBPACK FOOTER //
// ./src/utils.js